import React from 'react';
import { motion } from 'framer-motion';
const forWho = ['Mamás primerizas que quieren evitar problemas futuros.', 'Mujeres que fueron mamás hace años y aún sufren fugas de orina.', 'Quienes notan un "bulto" en el abdomen que no baja con dieta.', 'Mujeres que sienten pesadez pélvica al final del día.'];
const notForWho = ['Personas que buscan una solución mágica sin dedicar 15 minutos diarios.', 'Mujeres con cirugías abdominales recientes (menos de 8 semanas) sin alta médica.', 'Quienes prefieren invertir en cirugías costosas antes de intentar rehabilitar su cuerpo.'];
export function WhoIsForSection() {
  return <section className="py-12 md:py-24 bg-white" data-id="element-183">
      <div className="max-w-6xl mx-auto px-5 lg:px-8" data-id="element-184">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 lg:gap-20" data-id="element-185">
          {/* For Who */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-186">
            <h3 className="text-xl md:text-2xl font-serif text-charcoal mb-5 md:mb-8 flex items-center" data-id="element-187">
              <span className="w-6 md:w-8 h-px bg-rosegold mr-3 md:mr-4" data-id="element-188"></span>
              ESTE PROGRAMA ES PARA TI SI...
            </h3>
            <ul className="space-y-4 md:space-y-6" data-id="element-189">
              {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-190">
                  <svg className="w-5 h-5 md:w-6 md:h-6 text-rosegold mr-3 md:mr-4 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" data-id="element-191">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-192" />
                  </svg>
                  <span className="text-charcoal/80 text-base md:text-lg leading-relaxed" data-id="element-193">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Who */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} data-id="element-194">
            <h3 className="text-xl md:text-2xl font-serif text-charcoal mb-5 md:mb-8 flex items-center" data-id="element-195">
              <span className="w-6 md:w-8 h-px bg-charcoal/20 mr-3 md:mr-4" data-id="element-196"></span>
              NO ES PARA TI SI...
            </h3>
            <ul className="space-y-4 md:space-y-6" data-id="element-197">
              {notForWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-198">
                  <svg className="w-5 h-5 md:w-6 md:h-6 text-charcoal/30 mr-3 md:mr-4 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" data-id="element-199">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" data-id="element-200" />
                  </svg>
                  <span className="text-charcoal/60 text-base md:text-lg leading-relaxed" data-id="element-201">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}